(function ($) {
  "use strict";

  $(function () {
    // WOW init
    const wow = new WOW();
    wow.init();

    // Parallax bg
    if (document.querySelector(".parallax-bg")) {
      let parallaxElements = document.querySelectorAll(".parallax-bg");
      let initialOffsets = new Map();

      parallaxElements.forEach((element) => {
        initialOffsets.set(
          element,
          element.getBoundingClientRect().top + window.scrollY
        );
      });

      function setParallax() {
        if (window.innerWidth < 768) {
          parallaxElements.forEach((element) => {
            element.style.transform = "translateY(0px)";
          });
          return;
        }

        let scrollTop = window.scrollY;
        let windowHeight = window.innerHeight;

        parallaxElements.forEach((element) => {
          let initialTop = initialOffsets.get(element);
          let rect = element.getBoundingClientRect();
          let num = 0;
          let dir = element.getAttribute("data-parallax-dir") || "inc";
          let amount = element.getAttribute("data-parallax-amount") || 0.5;

          if (dir === "inc") {
            num = +amount;
          } else if (dir === "dec") {
            num = +amount * -1;
          }

          if (rect.bottom > 0 && rect.top < windowHeight) {
            let moveDistance = (scrollTop - initialTop) * num;
            element.style.transform = `translateY(${moveDistance}px)`;
          }
        });
      }

      if (parallaxElements.length > 0) {
        document.addEventListener("scroll", setParallax);
        window.addEventListener("resize", setParallax);
        setParallax();
      }
    }

    const filterElements = document.querySelectorAll(".js-filter-bg");

    if (filterElements.length > 0) {
      filterElements.forEach((element) => {
        const START_SATURATE = parseFloat(element.dataset.startSaturate) || 1;
        const END_SATURATE = parseFloat(element.dataset.endSaturate) || 1.5;
        const START_BRIGHTNESS =
          parseFloat(element.dataset.startBrightness) || 1;
        const END_BRIGHTNESS =
          parseFloat(element.dataset.endBrightness) || 0.25;
        const SPEED_FACTOR = parseFloat(element.dataset.speedFactor) || 5;

        window.addEventListener("scroll", () => {
          const rect = element.getBoundingClientRect();
          const sectionBottom = rect.bottom;
          const viewportHeight = window.innerHeight;

          const startPoint = viewportHeight - 100;
          const endPoint = 0;

          let progress = (startPoint - sectionBottom) / (startPoint - endPoint);
          progress = Math.max(0, Math.min(1, progress * SPEED_FACTOR));

          if (sectionBottom > startPoint) {
            element.style.filter = `saturate(${START_SATURATE}) brightness(${START_BRIGHTNESS})`;
            return;
          }

          const saturateValue =
            START_SATURATE + (END_SATURATE - START_SATURATE) * progress;
          const brightnessValue =
            START_BRIGHTNESS + (END_BRIGHTNESS - START_BRIGHTNESS) * progress;

          element.style.filter = `saturate(${saturateValue.toFixed(
            2
          )}) brightness(${brightnessValue.toFixed(2)})`;
        });
      });
    }

    const svg = document.getElementById("teaser-360-circle-svg");

    if (svg) {
      const textElement = svg.querySelector("text");

      // text rotation offset
      const offsetAngle = 180;

      const getScrollProgress = () => {
        const svgRect = svg.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const elementTop = svgRect.top;
        const elementBottom = svgRect.bottom;

        const visibleStart = windowHeight;
        const visibleEnd = -svgRect.height;

        const totalScrollDistance = visibleStart - visibleEnd;
        const currentScroll = visibleStart - elementTop;

        const scrollPercentage = currentScroll / totalScrollDistance;

        return Math.min(Math.max(scrollPercentage, 0), 1);
      };

      window.addEventListener("scroll", () => {
        const scrollPercentage = getScrollProgress();

        if (!isNaN(scrollPercentage)) {
          const rotationDegree = -scrollPercentage * 360; // Reversed direction
          const finalRotationValue = rotationDegree + offsetAngle;

          textElement.setAttribute(
            "transform",
            `translate(0, -5) rotate(${finalRotationValue} 0 300)`
          );
        }
      });
    }

    $(".js-scroll-to-teaser-form").on("click", function (e) {
      e.preventDefault();
      $(".js-teaser-360-form").get(0).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });

    $(".js-teaser-country").SumoSelect({
      placeholder: localize.translations.select_country,
      search: true, // Enable search inside dropdown
      searchText: localize.translations.select_country,
      csvDispCount: 3,
    });

    // Auto-fill phone country code when a country is selected
    $(".js-teaser-country").on("change", function () {
      var selectedOption = $(this).find(":selected");
      var countryCode = selectedOption.data("code") || "";

      $(this).next(".CaptionCont").addClass("CaptionCont--has-value");

      if (countryCode) {
        $(".js-telephone").val(countryCode);
      } else {
        $(".js-telephone").val("");
      }
    });

    function scrollbarWidth() {
      function setScrollbarWidth() {
        const html = document.documentElement;
        const scrollbarWidth = window.innerWidth - html.clientWidth;

        html.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
      }

      window.addEventListener("load", setScrollbarWidth);
      window.addEventListener("resize", setScrollbarWidth);
    }
    scrollbarWidth();

    // Scroll down to the next section

    const $scrollDownToNextSection = $(".js-scroll-down-to-next-section");

    if ($scrollDownToNextSection.length > 0) {
      $scrollDownToNextSection.on("click", function () {
        const wpAdminBarHeight = $("#wpadminbar").height() || 0;
        const sectionHeight = $scrollDownToNextSection
          .closest(".header")
          .outerHeight();

        $("html, body")
          .css("scroll-behavior", "initial")
          .animate(
            {
              scrollTop:
                $(window).scrollTop() + sectionHeight - wpAdminBarHeight,
            },
            1000,
            function () {
              $("html, body").css("scroll-behavior", "");
            }
          );
      });
    }

    function experienceSlider() {
      const $slider = $(".js-experience-slider");

      if ($slider.length === 0) return;

      const $slide1 = $slider.find(".js-experience-slider-item-1");
      const $slide2 = $slider.find(".js-experience-slider-item-2");
      const $prevButton = $slider.find(".js-experience-slider-prev");
      const $nextButton = $slider.find(".js-experience-slider-next");

      function switchSlide($slide, direction) {
        const $currentImg = $slide.find(
          ".js-experience-slider-img-box img.active"
        );
        let $newImg =
          direction === "next"
            ? $currentImg.next("img").length > 0
              ? $currentImg.next("img")
              : $slide.find(".js-experience-slider-img-box img").first()
            : $currentImg.prev("img").length > 0
              ? $currentImg.prev("img")
              : $slide.find(".js-experience-slider-img-box img").last();

        $currentImg.removeClass("active");
        $newImg.addClass("active");
      }

      function prev() {
        switchSlide($slide1, "prev");
        switchSlide($slide2, "prev");
      }

      function next() {
        switchSlide($slide1, "next");
        switchSlide($slide2, "next");
      }

      $prevButton.on("click", prev);
      $nextButton.on("click", next);
    }

    experienceSlider();

    function experienceSliderSm() {
      if (!document.querySelector(".js-experience-slider-sm")) return;

      const swiper = new Swiper(".js-experience-slider-sm", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: ".js-experience-slider-sm-next",
          prevEl: ".js-experience-slider-sm-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 1.1,
            spaceBetween: 24,
          },
        },
      });
    }

    experienceSliderSm();

    function amenitiesSlider() {
      if ($(".js-amenities-slider-thumbs").length === 0) return;

      const totalSlides = document.querySelectorAll(
        ".js-amenities-slider-thumbs .swiper-slide"
      ).length;
      const useDynamicSlidesPerView = totalSlides < 5;
      const slidesPerViewBase = useDynamicSlidesPerView ? totalSlides - 1 : 2;

      window.thumbsSwiper = new Swiper(".js-amenities-slider-thumbs", {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1.15,
        mousewheel: {
          forceToAxis: true,
        },
        speed: 500,
        navigation: {
          nextEl: ".js-amenities-slider-button-next",
          prevEl: ".js-amenities-slider-button-prev",
        },
        slideToClickedSlide: true,
        breakpoints: {
          992: {
            spaceBetween: 24,
            slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 2,
          },
          1400: {
            spaceBetween: 24,
            slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 3,
          },
          1600: {
            spaceBetween: 24,
            slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 4,
          },
        },
      });

      window.thumbsSwiperMobile = new Swiper(
        ".js-amenities-slider-thumbs-mobile",
        {
          loop: true,
          spaceBetween: 16,
          slidesPerView: 1.15,
          mousewheel: {
            forceToAxis: true,
          },
          speed: 500,
          navigation: {
            nextEl: ".js-amenities-slider-button-next",
            prevEl: ".js-amenities-slider-button-prev",
          },
          slideToClickedSlide: true,
          breakpoints: {
            992: {
              spaceBetween: 24,
              slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 2,
            },
            1400: {
              spaceBetween: 24,
              slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 3,
            },
            1600: {
              spaceBetween: 24,
              slidesPerView: useDynamicSlidesPerView ? totalSlides - 1 : 4,
            },
          },
        }
      );

      const mainSwiper = new Swiper(".js-amenities-slider", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: {
          forceToAxis: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        breakpoints: {
          992: {
            allowTouchMove: false,
            mousewheel: false,
          },
        },
      });

      thumbsSwiper.on("slideChange", function (swiper) {
        const index = swiper.realIndex;
        mainSwiper.slideTo(index, 500);
        const $els = $(".js-amenities-slider-texts");
        if ($els.length > 0) {
          $els.children().removeClass("is-active");
          $els.children().eq(index).addClass("is-active");
        }
      });

      thumbsSwiperMobile.on("slideChange", function (swiper) {
        const index = swiper.realIndex;
        const $els = $(".js-amenities-slider-texts");
        if ($els.length > 0) {
          $els.children().removeClass("is-active");
          $els.children().eq(index).addClass("is-active");
        }
      });
    }

    amenitiesSlider();

    function changeResidenceImg() {
      const $btn = $("[data-resisence-trigger-id]");
      const $img = $("[data-residence-id]");

      if ($btn.length === 0) return;

      $btn.on("change", function () {
        const _id = this.getAttribute("data-resisence-trigger-id");
        $img.removeClass("active");
        $img.filter('[data-residence-id="' + _id + '"]').addClass("active");
        $(".js-area").text(this.getAttribute("data-area"));
      });
    }

    changeResidenceImg();

    function sliderWithText() {
      if ($(".js-slider-with-text-slider").length === 0) return;

      const textSwiper = new Swiper(".js-slider-with-text-slider", {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: ".js-slider-with-text-slider-button-next",
          prevEl: ".js-slider-with-text-slider-button-prev",
        },
        breakpoints: {
          992: {
            spaceBetween: 0,
            slidesPerView: 1,
          },
        },
      });

      const imageSwiper = new Swiper(".js-slider-with-text-slider-img", {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          992: {
            spaceBetween: 0,
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: ".js-slider-with-text-slider-button-next",
          prevEl: ".js-slider-with-text-slider-button-prev",
        },
      });

      textSwiper.controller.control = imageSwiper;
      imageSwiper.controller.control = textSwiper;
    }

    sliderWithText();

    function setup360ViewObserver() {
      const $target = document.querySelector(".teaser-360-view");
      if (!$target) return;

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);

              const $section = $(".teaser-360-view");
              const $panorama = $("#jspanoramaviewer");
              const $btnClose = $(".js-360-view-close");

              if ($panorama.length === 0 || $section.length === 0) return;

              function initPan($pan, $btn) {
                const viewer = pannellum.viewer("jspanoramaviewer", {
                  type: "equirectangular",
                  panorama: $pan.data("image"),
                  mouseZoom: "fullscreenonly",
                  autoLoad: true,
                  showZoomCtrl: false,
                  keyboardZoom: false,
                  disableKeyboardCtrl: true,
                  showFullscreenCtrl: true,
                  showControls: true,
                  minPitch: -20,
                  maxPitch: 20,
                  /*  "autoRotate": -2 */
                });

                viewer.on("load", function () {
                  $section.addClass("is-open");
                });

                document
                  .getElementById("pan-left")
                  .addEventListener("click", function (e) {
                    viewer.setYaw(viewer.getYaw() - 10);
                  });
                document
                  .getElementById("pan-right")
                  .addEventListener("click", function (e) {
                    viewer.setYaw(viewer.getYaw() + 10);
                  });

                if ($btn.length > 0) {
                  $btn.on("click", function () {
                    $section.removeClass("is-open");

                    setTimeout(function () {
                      const $freshPan = $pan.clone();
                      const $freshBtn = $btn.clone();
                      $pan.replaceWith($freshPan);
                      $btn.replaceWith($freshBtn);
                      initPan($freshPan, $freshBtn);
                    }, 1000);
                  });
                }
              }

              initPan($panorama, $btnClose);
            }
          });
        },
        {
          root: null,
          threshold: 0.25,
        }
      );

      observer.observe($target);
    }

    setup360ViewObserver();

    function mobileNav() {
      const $btnOpen = $(".js-nav-mobile-btn-open");
      const $btnClose = $(".js-nav-mobile-btn-close");

      if ($btnOpen.length === 0) return;

      $btnOpen.on("click", function () {
        $("html").addClass("mobile-nav-is-open");
      });

      if ($btnClose.length === 0) return;

      $btnClose.on("click", function () {
        $("html").removeClass("mobile-nav-is-open");
      });
    }

    $(".js-header-nav-mobile-link").on("click", function () {
      $("html").removeClass("mobile-nav-is-open");
    });

    mobileNav();

    function rotationTextByScroll() {
      const els = document.querySelectorAll(".js-rotate-text");

      els.forEach((el) => {
        const parent = el.closest(".js-rotate-container") || el.parentElement;
        if (!parent) return;

        const parentRect = parent.getBoundingClientRect();
        const parentTop = parentRect.top + window.scrollY;
        const offset = parseFloat(el.getAttribute("data-offset")) || 0;
        const rotateNone = el.hasAttribute("data-no-rotate");
        const relativeScrollY = window.scrollY - parentTop;

        let rotationAngle = offset * 0.2;
        if (!rotateNone) {
          rotationAngle -= relativeScrollY * 0.2;
          requestAnimationFrame(() => {
            el.style.transform = `rotate(${rotationAngle}deg)`;
          });
        } else {
          rotationAngle = offset;
          el.style.transform = `rotate(${rotationAngle}deg)`;
        }
      });
    }

    window.addEventListener("scroll", rotationTextByScroll);
    rotationTextByScroll();

    // CircleType
    $.fn.circleType = function (options) {
      var settings = {
        dir: 1,
        position: "relative",
      };

      if (typeof $.fn.lettering !== "function") {
        console.error("Lettering.js is required");
        return;
      }

      return this.each(function () {
        if (options) {
          $.extend(settings, options);
        }

        var elem = this,
          delta = 180 / Math.PI,
          ch = parseInt($(elem).css("line-height"), 10),
          fs = parseInt($(elem).css("font-size"), 10),
          originalText =
            $(elem).attr("data-original-text") || elem.innerHTML.trim(),
          letters,
          center;

        // Ha még nincs elmentve az eredeti szöveg, mentjük
        if (!$(elem).attr("data-original-text")) {
          $(elem).attr("data-original-text", originalText);
        }

        // Megakadályozzuk a duplikációt
        if (!$(elem).find("span").length) {
          elem.innerHTML = originalText.replace(/\s/g, "&nbsp;");
          $(elem).lettering();
        }

        elem.style.position = settings.position;
        letters = elem.getElementsByTagName("span");
        center = Math.floor(letters.length / 2);

        var layout = function () {
          var tw = 0,
            offset = 0,
            minRadius,
            origin,
            innerRadius,
            l,
            style,
            r,
            transform;

          for (var i = 0; i < letters.length; i++) {
            tw += letters[i].offsetWidth;
          }

          minRadius = tw / Math.PI / 2 + ch;
          settings.radius = settings.radius || minRadius;

          if (settings.fluid && !settings.fitText) {
            settings.radius = Math.max(elem.offsetWidth / 2, minRadius);
          }

          origin =
            "center " +
            (settings.dir === -1 ? -settings.radius + ch : settings.radius) /
            fs +
            "em";
          innerRadius = settings.radius - ch;

          for (i = 0; i < letters.length; i++) {
            l = letters[i];
            offset += (l.offsetWidth / 2 / innerRadius) * delta;
            l.rot = offset;
            offset += (l.offsetWidth / 2 / innerRadius) * delta;
          }

          for (i = 0; i < letters.length; i++) {
            l = letters[i];
            style = l.style;
            r = (-offset * settings.dir) / 2 + l.rot * settings.dir;
            transform = "rotate(" + r + "deg)";

            style.position = "absolute";
            style.left = "50%";
            style.marginLeft = -(l.offsetWidth / 2) / fs + "em";

            style.transform = transform;
            style.transformOrigin = origin;

            if (settings.dir === -1) {
              style.bottom = 0;
            }
          }

          updateHeight();
          if ($(elem).hasClass("js-teaser-360-modal-decor-lg")) {
            $(elem).addClass("active");
            const $replacement = $(elem);

            $(".js-decor-wrapper-lg").replaceWith($replacement.clone());
            $replacement.remove();
          }

          if ($(elem).hasClass("js-teaser-360-modal-decor-sm")) {
            $(elem).addClass("active");
            const $replacement = $(elem);

            $(".js-decor-wrapper-sm").replaceWith($replacement.clone());
            $replacement.remove();
          }
        };

        var updateHeight = function () {
          var getBounds = function (elem) {
            var box = elem.getBoundingClientRect();
            return {
              top: box.top + window.pageYOffset,
              height: box.height,
            };
          };

          var mid = getBounds(letters[center]),
            first = getBounds(letters[0]),
            h = Math.abs(mid.top - first.top) + first.height;

          elem.style.height = h + "px";
        };

        if (settings.fluid && !settings.fitText) {
          $(window).on("resize", function () {
            layout();
          });
        }

        if (document.readyState !== "complete") {
          elem.style.visibility = "hidden";
          $(window).on("load", function () {
            elem.style.visibility = "visible";
            layout();
          });
        } else {
          layout();
        }

        // **Újraméretezés kezelése**
        $(window).on("resize", function () {
          layout();
        });
      });
    };

    $(".js-teaser-360-experience-slider-img-decor-sm").circleType({
      dir: 1,
      radius: 65,
    });
    $(".js-teaser-360-experience-slider-img-decor-lg").circleType({
      dir: 1,
      radius: 150,
    });
    $(".js-teaser-360-map-decor-sm").circleType({ dir: 1, radius: 65 });
    $(".js-teaser-360-map-decor-lg").circleType({ dir: 1, radius: 90 });
    $(".js-teaser-360-amenities-decor-sm").circleType({ dir: 1, radius: 70 });
    $(".js-teaser-360-amenities-decor-lg").circleType({ dir: 1, radius: 140 });
    $(".js-teaser-360-half-text-half-img-decor-sm").circleType({
      dir: 1,
      radius: 75,
    });
    $(".js-teaser-360-half-text-half-img-decor-lg").circleType({
      dir: 1,
      radius: 140,
    });
    $(".js-teaser-360-modal-decor-lg").circleType({ dir: 1, radius: 90 });
    $(".js-teaser-360-modal-decor-sm").circleType({ dir: 1, radius: 60 });

    function cropTextByScroll() {
      const elements = document.querySelectorAll(".js-crop-text");
      if (elements.length === 0) return;

      const windowHeight = window.innerHeight;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const elementCenter = rect.top + rect.height / 2;

        const scrollStartPercent =
          parseFloat(element.getAttribute("data-scroll-start")) || 20;
        const scrollEndPercent =
          parseFloat(element.getAttribute("data-scroll-end")) || 80;
        const fromAngle =
          parseFloat(element.getAttribute("data-gradient-from")) || 0;
        const rotateStart =
          parseFloat(element.getAttribute("data-gradient-start")) || 0;
        const rotateOffset =
          parseFloat(element.getAttribute("data-rotate-offset")) || 0;

        const scrollStart = windowHeight * (scrollStartPercent / 100);
        const scrollEnd = windowHeight * (scrollEndPercent / 100);

        let progress = 0;
        if (elementCenter <= scrollStart) {
          progress = 0;
        } else if (elementCenter >= scrollEnd) {
          progress = 1;
        } else {
          progress = (elementCenter - scrollStart) / (scrollEnd - scrollStart);
        }

        const posOffset = (1 - progress) * 100;

        element.style.setProperty("--from", fromAngle + "deg");
        element.style.setProperty("--pos", posOffset + "%");

        const rotation = rotateOffset + (rotateStart + progress * 360);
        element.style.transform = `rotate(${rotation}deg)`;
      });
    }

    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          cropTextByScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll);
    onScroll();

    // Intersection Observer for .js-360-form
    const $formElement = $('.js-360-form');
    if ($formElement.length) {
      const formElement = $formElement.get(0);
      let hasTriggered = false;

      const formObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !hasTriggered) {
              hasTriggered = true;
              $(".js-which-residential").trigger('change');
              formObserver.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.25,
          rootMargin: '200px 0px',
        }
      );

      formObserver.observe(formElement);
    }

  });
})(jQuery);
